/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

type CutWireModalState = Readonly<{
    isOpen: boolean;
    cartLine: CartLineModel;
}>;

const initialModalState: CutWireModalState = {
    isOpen: false,
    cartLine: {} as CartLineModel,
};

const reducer = {
    "CutWire/SetModalOpened": (
        draft: Draft<CutWireModalState>,
        action: { isOpen: boolean; cartLine: CartLineModel },
    ) => {
        draft.isOpen = action.isOpen;
        draft.cartLine = action.cartLine;
    },
    "CutWire/SetModalClosed": (draft: Draft<CutWireModalState>, action: { isOpen: boolean }) => {
        draft.isOpen = action.isOpen;
        draft.cartLine = {} as CartLineModel;
    },
};

const cutWireModal = createTypedReducerWithImmer(initialModalState, reducer);

(reducers as any).cutWireModal = cutWireModal;

export type cutWireState = {
    cutWireModal: CutWireModalState;
};

type cutWireReducers = {
    isOpen: typeof cutWireModal;
    cartLine: typeof cutWireModal;
};

export type cutWireActions = Parameters<cutWireReducers[keyof cutWireReducers]>[1] | AnyAction;
